define(["componentClasses/popover"], function(Popover) {

    var copyToClipboard = function(str) {
        // Create a <textarea> element, set its value to the string that you want copied, make it readonly, invisible and append the <textarea> element to the HTML document
        const el = document.createElement('textarea');
        el.value = str;
        el.setAttribute('readonly', '');
        el.style.position = 'absolute';
        el.style.left = '-9999px';
        document.body.appendChild(el);

        // Check if there is any content selected previously and tore selection if found
        const selected =
          document.getSelection().rangeCount > 0
            ? document.getSelection().getRangeAt(0)
            : false;

        // Select the <textarea> content and copy - only works as a result of a user action (e.g. click events)
        el.select();
        document.execCommand('copy');

        // Cleanup: Remove the <textarea> element and if a selection existed before copying, unselect everything on the HTML document and restore the original selection
        document.body.removeChild(el);
        if (selected) {
            document.getSelection().removeAllRanges();
            document.getSelection().addRange(selected);
        }
    };

    return {
        name: "clipboard",
        apply: function($element, params) {
            $element.on("click", function(ev) {
                ev.preventDefault();
                var text = $element.text();
                if(params.src) {
                    text = $("#" + params.src).text();
                }
                copyToClipboard(text);
                setTimeout(function() {
                    params.html = 'Copied!';
                    params.origin = $element;
                    var popover = new Popover(params);
                    popover._clearAllPopovers();
                    popover.place();
                }, 100);
            });
        }
    };
});


